import { defineComponent, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { KahiDetailData } from "@/@types";
import KahiDetailRelation from "@/components/KahiDetailRelation/KahiDetailRelation.vue";
import KahiMetaInfo from "@/components/KahiMetaInfo/KahiMetaInfo.vue";
import KahiPhoto from "@/components/KahiPhoto/KahiPhoto.vue";
import { breakLineUta, convertDistance, convertParagraph } from "@/filters";
import store from "@/store";

export default defineComponent({
  name: "AsyncKahiDetail",
  components: {
    KahiDetailRelation,
    KahiMetaInfo,
    KahiPhoto
  },
  async setup() {
    const route = useRoute();
    const detail = ref<KahiDetailData | null>(null);
    const error = ref(false);
    const distance = ref<number | null>(null);

    const calcurateDistance = async () => {
      distance.value = await store.dispatch(
        "kahi/calcurateDistance",
        detail.value !== null ? detail.value.coords : null
      );
    };

    const loadKahi = async () => {
      error.value = false;

      await store
        .dispatch("kahi/getKahi", route.params.detailId)
        .then(async (data: KahiDetailData) => {
          detail.value = data;
          error.value = false;
          await calcurateDistance();
        })
        .catch(() => {
          detail.value = null;
          error.value = true;
        });
    };

    watch(
      () => route.params.detailId,
      async newParams => {
        if (newParams) {
          await loadKahi();
        }
      }
    );

    watch(
      () => store.state.kahi.currentPosition,
      async () => {
        calcurateDistance();
      }
    );

    await loadKahi();

    return {
      detail,
      distance,
      error,
      breakLineUta,
      convertDistance,
      convertParagraph
    };
  }
});
